<template>
  <section  class=" destinations places ">
    <b-container class="cards-container">
      <div class="main_title">
        <h1 class="text-center">
          <strong>
  بعض الأماكن الخاصة
          </strong>
          برحلات أجازة بوك
        </h1>
        <UnderLine/>
      </div>
      <b-row>
        <b-col sm="3"  class="col-6" v-for="s in 4" :key="s">
          <WorldTourCard/>
        </b-col>
      </b-row>
      <b-row>
        <div class="see-more">
           <b-button variant="primary">المزيد</b-button>
        </div>
      </b-row>
    </b-container>
  </section>
</template>
<script type="text/javascript">
  import WorldTourCard from '../global/WorldTourCard'
  import UnderLine     from '../global/UnderLine'

  export default {
    name:'Places',
    components: {
      WorldTourCard,
      UnderLine,

    },
    data() {
      return {

      }
    }
  }
</script>
